import { defineComponent as f, computed as o, createBlock as p, openBlock as m, unref as d, mergeProps as h, withCtx as w, createElementVNode as n, createVNode as x, normalizeClass as s, renderSlot as r, createTextVNode as v, toDisplayString as g } from "vue";
import { RevButtonBase as B } from "@ds/components/ButtonBase";
import S from "../../../icons/generated/IconChevronDown.vue2.js";
import { tw as e } from "../../../utils/tailwind.js";
const y = ["for"], $ = /* @__PURE__ */ f({
  name: "InputSelectButton",
  inheritAttrs: !1,
  __name: "InputSelectButton",
  props: {
    hasError: { type: Boolean },
    disabled: { type: Boolean },
    focused: { type: Boolean },
    hasSelectedOption: { type: Boolean },
    required: { type: Boolean },
    selectId: {}
  },
  setup(a) {
    const t = a, i = o(() => [
      e`pointer-events-none absolute inset-x-12 top-0 flex items-center pr-16`,
      !t.disabled && t.hasSelectedOption && e`text-static-default-low top-4 h-auto`,
      !t.disabled && !t.hasSelectedOption && e`text-action-default-hi`,
      t.disabled && e`text-static-default-low-disabled`,
      t.hasSelectedOption ? e`caption` : e`body-1 h-full`
    ]), c = o(() => [
      e`rounded-sm body-1 absolute inset-x-0 bottom-2 size-full grow`,
      e`appearance-none truncate border-0 bg-transparent text-start outline-none`
    ]), u = o(() => [
      e`pointer-events-none absolute right-12 shrink-0 select-none`,
      t.disabled && e`text-static-default-low-disabled`,
      !t.disabled && t.hasSelectedOption && e`text-static-default-low`,
      !t.disabled && !t.hasSelectedOption && e`text-action-default-hi`
    ]), b = o(() => [
      e`rounded-sm relative flex h-48 w-full items-center border px-12`,
      e`ease-in-out motion-safe:transition-colors motion-safe:duration-200`,
      t.focused && !t.hasError && e`border-action-default-low-focus outline-default-low`,
      t.focused && t.hasError && e`border-action-danger-low-focus outline-danger-low`,
      !t.disabled && e`bg-static-default-low text-action-default-hi hover:bg-static-default-low-hover`,
      !t.disabled && t.hasError ? e`border-action-danger-low` : e`border-action-default-low`,
      t.disabled && e`bg-static-default-low-disabled border-action-default-low-disabled text-action-default-hi-disabled cursor-not-allowed`
    ]);
    return (l, C) => (m(), p(d(B), h({
      "aria-disabled": a.disabled,
      class: b.value,
      disabled: a.disabled
    }, l.$attrs), {
      default: w(() => [
        n("label", {
          class: s(i.value),
          for: a.selectId
        }, [
          r(l.$slots, "label"),
          v(g(a.required ? " *" : ""), 1)
        ], 10, y),
        n("span", {
          class: s(c.value)
        }, [
          r(l.$slots, "value")
        ], 2),
        x(d(S), {
          class: s(u.value),
          size: "20"
        }, null, 8, ["class"])
      ]),
      _: 3
    }, 16, ["aria-disabled", "class", "disabled"]));
  }
});
export {
  $ as default
};
